module.exports = __webpack_public_path__ + "img/utalkNoTime.c28024e6.png";